import { render, staticRenderFns } from "./DeleteOrArchive.vue?vue&type=template&id=a68e52d6"
import script from "./DeleteOrArchive.vue?vue&type=script&lang=js"
export * from "./DeleteOrArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports